export default __webpack_public_path__ + "static/media/studentModalLiveCourse.6ee943bb.svg";